import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import VueResource from 'vue-resource'
Vue.use(VueResource)

// import Vant from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Vant);

// import { Locale } from 'vant';
// // 引入语言包
// import zhHK from 'vant/es/locale/lang/zh-HK';
// Locale.use('zh-HK', zhHK);


new Vue({
  render: h => h(App),
}).$mount('#app')



